import React from 'react';
import { Link } from 'gatsby';
import StrapiImage from '../util/StrapiImage';
import { useStrapiContext } from '../context/StrapiContext';
//import { Link } from 'gatsby-plugin-google-gtag';

import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaClock,
  FaEnvelope,
} from 'react-icons/fa';

function formatPhoneNumber(phoneNumber) {
  const cleaned = ('' + phoneNumber).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const formattedNumber = `(${match[1]}) ${match[2]} ${match[3]}`;
    return (
      <a
        href={`tel:+1${phoneNumber}`}
        className="unstyled-link"
      >{`${formattedNumber} `}</a>
    );
  }
  return null;
}

const Column = ({ title, links }) => (
  <div className="mx-auto md:mx-0 md:mr-6 flex flex-col space-y-4 md:space-y-1 w-[200px]">
    {/* <p className="text-lg md:text-sm mt-0 font-bold uppercase text-brandLight underline">{title}</p> */}
    {links.map((link, index) => (
      <Link
        key={index}
        to={link.to}
        className="text-md text-blue-900 hover:underline"
      >
        {link.text}
      </Link>
    ))}
  </div>
);

const columns = [
  {
    title: 'Company',
    links: [
      { to: '/about-us', text: 'About' },
      { to: '/contact', text: 'Contact' },
      { to: '/faq', text: 'FAQ' },
      { to: '/blog', text: 'Blog' },
      { to: '/gallery', text: 'Gallery' },
      { to: '/careers', text: 'Careers' },
      { to: '/giving-back', text: 'Giving Back' },
      { to: '/customer-reviews', text: 'Customer Reviews' },
    ],
  },
  {
    title: 'Services',
    links: [
      { text: 'Areas We Serve', to: '/services/service-area' },
      { text: 'Replacement Windows', to: '/services/replacement-windows' },
      { text: 'Patio Doors', to: '/services/patio-doors' },
      { text: 'Entry Doors', to: '/services/entry-doors' },
      { text: 'Pet Doors', to: '/services/pet-doors' },
      { text: 'Warranty', to: '/services/warranty' },
      { text: 'Care and Maintenance', to: '/care-and-maintenance' },
    ],
  },
  {
    title: 'Offers',
    links: [
      { text: 'Get a Free Estimate', to: '/get-quote' },
      { text: 'Financing & Promotions', to: '/offers-and-promotions' },
      {
        text: `Anlin's Mfr. Statement for Tax Credit`,
        to: 'https://typical-courage-66f007be10.media.strapiapp.com/Anlin_FTCE_2023_89cb8a808d.pdf',
      },
      
    ],
  },
];

const SocialIcons = () => {
  return (
    <div className="md:my-auto">
      <ul className="flex flex-wrap items-center justify-center text-white">
        {/* FACEBOOK */}
        <li className="mx-4 transform transition-transform hover:scale-110">
          <a
            href="https://www.facebook.com/ClarityWindowsAndDoors/"
            className="text-white hover:underline md:mx-4"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              width="20px"
              style={{ fill: '#005ca8' }}
              role="img"
              aria-label="Visit our Facebook page"
            >
              <path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z" />
            </svg>
          </a>
        </li>

        {/* LINKEDIN */}
        <li className="mx-4 transform transition-transform hover:scale-110">
          <a
            href="https://www.linkedin.com/company/clarity-windows-and-doors"
            className="text-#005ca8 hover:underline md:mx-4"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              width="20px"
              style={{ fill: '#005ca8' }}
              role="img"
              aria-label="Visit our LinkedIn page"
            >
              <path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z" />
            </svg>
          </a>
        </li>

        {/* YOUTUBE */}
        <li className="mx-4 transform transition-transform hover:scale-110">
          <a
            href="https://www.youtube.com/@claritywindowsanddoors1086"
            className="text-#005ca8 hover:underline md:mx-4"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
              width="20px"
              style={{ fill: '#005ca8' }}
              role="img"
              aria-label="Visit our YouTube page"
            >
              <path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z" />
            </svg>
          </a>
        </li>

        {/* INSTAGRAM */}
        <li className="mx-4 transform transition-transform hover:scale-110">
          <a
            href="https://www.instagram.com/claritywindowsanddoors/"
            className="text-#005ca8 hover:underline md:mx-4"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              width="20px"
              style={{ fill: '#005ca8' }}
              role="img"
              aria-label="Visit our Instagram page"
            >
              <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
            </svg>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default function Footer() {
  let date = new Date().getFullYear();
  const strapi = useStrapiContext();
  const logo =
    strapi.strapiGlobal.logo.localFile.childImageSharp.gatsbyImageData;
  //const companyName = strapi.strapiGlobal.companyName;
  const supportEmail =
    strapi.strapiGlobal.supportEmail || 'support@overpassmarketing.com';
  const phone =
    formatPhoneNumber(strapi.strapiGlobal.mainPhone) || '(888) 888-8888';
  const address = strapi.strapiGlobal.address[0] || '';
  const businessHours = strapi.strapiGlobal.businessHours || '';

  return (
    <footer className="z-50 flex flex-col justify-center bg-white p-4 md:p-8 lg:p-10">
      <div className="flex flex-col justify-center md:flex-row md:justify-between px-0">
        <Link className="justify-center flex my-6 md:my-0 align-middle" to="/">
          <StrapiImage
            img={logo}
            className="transform transition-transform hover:scale-110 w-[200px]"
            
          />
        </Link>
        <SocialIcons />
      </div>
      <hr className="my-8" />

      <div className="flex w-full flex-col justify-between gap-10 px-10 text-center md:flex-row md:gap-6 md:text-left">
        <div className="mx-auto md:mx-0">
          <div className="flex flex-col text-center text-brandLight md:text-left md:mr-20">
            <div className="flex items-center text-sm uppercase mb-4 mx-auto md:mx-0">
              <FaMapMarkerAlt className="mr-4" role="img" aria-label="Address" />
              <div className="">
                {address.street}
                <br />
                {address.city}, {address.state} {address.zip}
              </div>
            </div>
            <div className="flex items-center text-sm uppercase mb-4 mx-auto md:mx-0">
              <FaPhoneAlt className="mr-4" role="img" aria-label="Phone number" />
              <div>
                <div>DFW: {phone}</div>
                <div>TEXOMA: {formatPhoneNumber(9034517577)}</div>
              </div>
            </div>

            <div className="flex items-center text-sm uppercase mb-4 mx-auto md:mx-0">
              <FaClock className="mr-4" role="img" aria-label="Business hours" />
              <p className="text-brandLight text-sm my-0">{businessHours}</p>
            </div>
            <div className="flex items-center text-sm uppercase mb-4 mx-auto md:mx-0">
              <FaEnvelope className="mr-4" role="img" aria-label="Email" />
              <a href={`mailto:${supportEmail}`} className="text-brandLight">
                {supportEmail}
              </a>
            </div>
            <div className="flex items-center text-sm uppercase mb-4 mx-auto md:mx-0">
              {/* <FaHome className="mr-4" /> */}
              <Link to={`/window-showroom-near-me`}>
                <p className="text-brandLight text-sm my-0">
                  Showroom open to the
                  <br /> public by appointment
                </p>
              </Link>
            </div>
          </div>
        </div>
        {columns.map((column, index) => (
          <Column key={index} title={column.title} links={column.links} />
        ))}
      </div>
      <hr className="my-8" />
      <div className="text-left text-sm text-gray-400 md:mx-20">
        © {date} Clarity Windows and Doors. All rights reserved. Read our{' '}
        <Link to="/privacy-policy" className="unstyled-link underline">
          Privacy Policy
        </Link>
        .
        <br />
        <br />
        Clarity Windows and Doors is committed to providing a website accessible
        to the widest possible audience, regardless of technology or ability. If
        you experience any difficulty accessing any part of this website, please
        email us at {supportEmail} or call us at {phone}. We will work with you
        to provide the information, item, or transaction you seek through an
        alternate communication method consistent with applicable law.
        <br />
        <br />
        Clarity Windows<sup>®</sup> is a registered trademark. All rights
        reserved.
      </div>
    </footer>
  );
}
